import { Http } from './http';

class LoanDataHttp extends Http {
  prefix = 'loan-data';

  async updateBulk(params: UpdateBulkParams): Promise<number> {
    const { data } = await this.put<number>('/update-bulk', params);

    return data;
  }
}

export const loanDataHttp = new LoanDataHttp();

interface UpdateBulkParams {
  selectedIds: number[];
  prop: string;
  value: string | number | null;
}

